export default "__VITE_ASSET__fb020a5a__"